module.exports = __webpack_public_path__ + "img/icon2.84e82814.png";